<template>
<div class="chapter">
<div class="inner_page">
<p class="c2" id="calibre_pb_0"><img alt="tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM_html_1fb9897e.jpg" class="calibre3" id="Picture_20" src="tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM_html_1fb9897e.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue?6aedfd3a